var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isNeededToShowPopup
    ? _c("div", { staticClass: "newsletter-popup" }, [
        _c("div", { staticClass: "text-block" }, [
          _c(
            "button",
            { staticClass: "modalClose", on: { click: _vm.closePopup } },
            [
              _c("svg-icon", {
                attrs: { "icon-class": "bbb", "icon-name": "icon-cross" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("svg", [
            _c("use", {
              attrs: {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": "/i/newsletter_icon.svg#Laag_1",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top-text" }, [
            _vm._v(
              "\n            Become a true insider of FUTURUM Quality Gear!\n            Subscribe to our newsletter and get a\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("20% discount")]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [
            _vm._v("\n            on your order above €100\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-container footerNewsletter" }, [
            _c("div", [
              !_vm.successfullySent
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputValue,
                        expression: "inputValue",
                      },
                    ],
                    staticClass: "text",
                    attrs: {
                      type: "text",
                      name: "email",
                      placeholder: "Please fill in your email address",
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      change: _vm.inputOnChange,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.inputValue = $event.target.value
                      },
                    },
                  })
                : _c(
                    "div",
                    { staticClass: "notification newsletter success" },
                    [
                      _c("div", { staticClass: "text-success-title" }, [
                        _vm._v("success!"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n                        Please have a look in your mailbox to\n                        find the discount code for 20% off.\n                    "
                        ),
                      ]),
                    ]
                  ),
              _vm._v(" "),
              !_vm.successfullySent
                ? _c(
                    "button",
                    {
                      class: [
                        "button",
                        "medium",
                        "ghostWhite",
                        "check-form",
                        { isErrorLongText: _vm.isErrorLongText() },
                      ],
                      attrs: { name: "subscribe" },
                      on: { click: _vm.subscribeClick },
                    },
                    [_c("span", [_vm._v("Subscribe")])]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.errorAppeared
              ? _c(
                  "div",
                  {
                    class: [
                      "notice",
                      "notice-error",
                      { isErrorLongText: _vm.isErrorLongText() },
                    ],
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.errorAppeared)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "newsletter-popup-background" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "/svg/icon-error.svg", alt: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }